"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _reactRedux = require("react-redux");

var _redux = require("redux");

var _selectedCharacteristics = require("../../actions/campaignCreator/selectedCharacteristics");

var _Question = _interopRequireDefault(require("../../components/Question"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

// get something out of global store
var mapStateToProps = function mapStateToProps(state, props) {
  return {
    selectedCharacteristics: state.selectedCharacteristics
  };
}; // bind our actions into redux (allow them to talk to redux)


var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return (0, _redux.bindActionCreators)({
    addSelectedCharacteristic: _selectedCharacteristics.addSelectedCharacteristic,
    removeSelectedCharacteristic: _selectedCharacteristics.removeSelectedCharacteristic
  }, dispatch);
};

var _default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_Question["default"]);

exports["default"] = _default;